import React from 'react';
export function ApiIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h-3v-4h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V6c0-1.1-.9-2-2-2h-2c-4.07 0-7.44 3.06-7.93 7H3c-.55 0-1 .45-1 1s.45 1 1 1h3.07c.49 3.94 3.86 7 7.93 7h2c1.1 0 2-.9 2-2v-2h3c.55 0 1-.45 1-1s-.45-1-1-1zm-7 4c-3.31 0-6-2.69-6-6s2.69-6 6-6h2v11.98h-2V18z"
  }));
}